import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListDeductions = () => {
    return axios.get(`/api/Pay/deduction/list`, { headers: authHeaderJson() } )
};

const getDeductionById = (deductionId) => {
        return axios.get(`/api/Pay/deduction/${deductionId}`, { headers: authHeaderJson() } );
};

const addDeduction = (deduction) => {
    return axios.post(`/api/Pay/deduction/add/`, deduction, { headers: authHeaderJson() } );
}

const addDeductionList = (deductions) => {
    return axios.post(`/api/Pay/deduction/add/list`, deductions, { headers: authHeaderJson() } );
}

const saveDeductionById = (deductionId, objDeduction) => {
    return axios.put(`/api/Pay/deduction/${deductionId}`, objDeduction, { headers: authHeaderJson() });
};

const deleteDeduction = (deductionId) => {
    return axios.delete(`/api/Pay/deduction/${deductionId}`, { headers: authHeaderJson() });
}

export {
    getListDeductions,
    getDeductionById,
    addDeduction,
    addDeductionList,
    saveDeductionById,
    deleteDeduction
}